import { useCallback } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import type { ButtonType } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";

import { useShowsIndustryTaxonomyAdminOffer } from "../hooks/useShowsIndustryTaxonomyAdminOffer";
import { usePrefetchImpactReport } from "../queries/usePrefetchImpactReport";
import industryTrackingService from "../services/tracking/trackingService";
import { useIndustryTransitionModalStore } from "../store/useIndustryTransitionModalStore";
import { industryTransitionKeys } from "../utils/i18n";

type IndustryTransitionEnrollButtonProps = {
    /** The design-system `ButtonType`, so a surface can pick `inverted` on a coloured banner without a wrapper prop. */
    readonly type?: ButtonType;
};

/**
 * Opens the impact report. Self-gated on the admin offer, so every surface can render it
 * unconditionally; only the modal it opens is mounted at the SI root.
 */
export const IndustryTransitionEnrollButton = ({ type = "primary" }: IndustryTransitionEnrollButtonProps) => {
    const { translate } = useTranslate();

    const showsAdminOffer = useShowsIndustryTaxonomyAdminOffer();
    const open = useIndustryTransitionModalStore((state) => state.open);
    const prefetchImpactReport = usePrefetchImpactReport();

    const handleOpen = useCallback(() => {
        industryTrackingService.trackImpactReportOpen();
        open();
    }, [open]);

    if (!showsAdminOffer) {
        return null;
    }

    return (
        <Button
            type={type}
            buttonHtmlType="button"
            onClick={handleOpen}
            onMouseEnter={prefetchImpactReport}
            data-automation="industry-transition-enroll-button"
        >
            {translate(industryTransitionKeys.bannerEnrollCta)}
        </Button>
    );
};
